import SignatureIcon from '@honeybook/icons/dist/icons/Signature24';
import DollarCircleIcon from '@honeybook/icons/dist/icons/DollarCircle24';
import CalendarIcon from '@honeybook/icons/dist/icons/Calendar24';
import ServicesIcon from '@honeybook/icons/dist/icons/Services24';
import DividerIcon from '@honeybook/icons/dist/icons/Divider';
import ImageIcon from '@honeybook/icons/dist/icons/Image24';
import QuestionMarkIcon from '@honeybook/icons/dist/icons/QuestionMark24';
import TextIcon from '@honeybook/icons/dist/icons/Text24';
import VideoIcon from '@honeybook/icons/dist/icons/Video24';
import CompositionIcon from '@honeybook/icons/dist/icons/Composition24';
import CompanyInfoIcon from '@honeybook/icons/dist/icons/CompanyInfo24';
import Web24 from '@honeybook/icons/dist/icons/Web24';
import { BaseBlockType } from '~/types/builder.types';
import {
    CompositionType,
    TActionBlocks,
    TBlockType
} from '~/types/model.types';
import { TFuncKey } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

// --------------------------- ELEMENT IDS --------------------------- //
export const BUILDER_CANVAS_ID = 'builder-canvas';

export const BUILDER_CANVAS_EMPTY_STATE_TEST__ID = 'builder-canvas-empty-state';
export const BUILDER_SIDEBAR_CLOSE_BUTTON_ID = 'builder-sidebar-close-button';
export const PRINT_CONTENT_CONTAINER_ID = 'PrintContentContainer';
export const ROOT_BLOCK_ID = 'one-flow-builder-root-block';
export const CONTRACT_MODAL_ID = 'contractModal';
// ------------------------------------------------------------------- //

// --------------------------- TEMPLATES IDS --------------------------- //
export const BLANK_INVOICE_ID = '630dbe26f4832d002ce9e196';
// ------------------------------------------------------------------- //

export const SUB_TITLE_TEXT =
    'Fill out the information below to add a new participant to the project and allow them to interact with this file.';

export const BASE_ACTION_BLOCK_TYPES: Partial<BaseBlockType>[] = [
    {
        name: 'Contract',
        type: 'contract_block',
        icon: SignatureIcon
    },
    {
        name: 'Invoice & Pay',
        type: 'invoice_container_block',
        icon: DollarCircleIcon
    },
    {
        name: 'Schedule',
        icon: CalendarIcon,
        comingSoon: true
    },
    {
        name: 'Services',
        type: 'service_selection_block',
        icon: ServicesIcon,
        comingSoon: true
    }
];

export const COMPANY_INFO_TYPE: BaseBlockType = {
    name: 'Company Info',
    type: 'company_info_block',
    compositionType: CompositionType.CompanyInfo,
    icon: CompanyInfoIcon
};

export const BASE_BLOCK_TYPES: BaseBlockType[] = [
    {
        name: 'Composition',
        type: 'container_block',
        compositionType: CompositionType.Default,
        icon: CompositionIcon
    },
    {
        name: 'Questions',
        type: 'question_block',
        icon: QuestionMarkIcon
    },
    {
        name: 'Text',
        type: 'text_block',
        icon: TextIcon
    },
    {
        name: 'Image',
        type: 'image_block',
        icon: ImageIcon
    },
    { ...COMPANY_INFO_TYPE },
    {
        name: 'Video',
        type: 'video_block',
        icon: VideoIcon
    },
    {
        name: 'Divider',
        type: 'spacer_block',
        icon: DividerIcon
    },
    {
        name: 'iframe',
        type: 'iframe_block',
        icon: Web24
    }
];

export const BOOKABLE_BLOCK_TYPES: Partial<TBlockType>[] = [
    'contract_block',
    'invoice_container_block'
];

export const SHORT_HEIGHT_BLOCK_TYPES: Partial<TBlockType>[] = [
    'text_block',
    'spacer_block'
];

export const actionBlockTypes: Readonly<
    Record<TActionBlocks, TFuncKey<[typeof NAMESPACES.GLOBALS]>>
> = {
    contract_block: 'globals:flow_action_blocks.contract',

    // old invoices before recurring might return this
    invoice_container_block: 'globals:flow_action_blocks.invoice',

    payment_schedule_block: 'globals:flow_action_blocks.invoice',
    recurring_schedule_block: 'globals:flow_action_blocks.recurring_invoice',
    charge_container_block: 'globals:flow_action_blocks.charge',
    services_block: 'globals:flow_action_blocks.services',
    service_selection_block: 'globals:flow_action_blocks.services',
    schedule_container_block: 'globals:flow_action_blocks.schedule'
};

export const DEFAULT_PROFILE_IMAGE_FILENAME = 'empty_default_image';

export const MIN_CLEARING_AMOUNT = 0.5;

export const DATE_PICKER_PLACEHOLDER = 'MM/DD/YY';

export const WORKSPACE_EMAIL_STORAGE_KEY = 'workspace';
export const SHARE_SMAF_EMAIL_STORAGE_KEY = 'SHARE_SMAF';
export const PUBLISH_CHANGES_SMAF_EMAIL_STORAGE_KEY = 'PUBLISH_CHANGES_SMAF';
export const REQUEST_PAYMENT_EMAIL_STORAGE_KEY = 'REQUEST_PAYMENT';
export const STOP_RECURRING_EMAIL_STORAGE_KEY = 'STOP_RECURRING';

export const TOAST_IDS = {
    RESUME_RECURRING: 'resumeRecurringToast',
    ERRORS_BUILDER: 'errorsBuilderToast',
    INVOICE_COLUMNS_UPDATED: 'invoiceColumnsUpdatedToast',
    INCOMPLETE_BLOCK_TOAST_ID: 'incompleteBlockToast'
};
